import { citySchema } from "../configs";
import { useCreateCityMutation } from "../store";
import { showToast, ToastType } from "../utils/toast.utils";
import CityForm from "../forms/City.form";

const CreateCity: React.FC = () => {
  const [CreateCity, { isLoading }] = useCreateCityMutation();

  const initialValues = {
    displayName: "",
    coordinates: [0, 0],
  };

  return (
    <div className="p-4 w-full">
      <CityForm
        initialValues={initialValues}
        validationSchema={citySchema}
        isLoading={isLoading}
        onSubmit={async (values, { resetForm }) => {
          values.coordinates = values.coordinates.map((c: string) => +c);
          const result = await CreateCity(values);
          if (!result.error) {
            showToast("Catégorie créée", ToastType.SUCCESS);
            resetForm();
          }
        }}
      />
    </div>
  );
};

export default CreateCity;
